// Translations for Lees is Duidelik
// Supports Afrikaans (af) and English (en)

export const translations = {
  af: {
    translation: {
      // Common
      loading: "Laai...",
      save: "Stoor",
      cancel: "Kanselleer",
      delete: "Verwyder",
      edit: "Wysig",
      back: "Terug",
      next: "Volgende",
      submit: "Indien",
      close: "Sluit",
      yes: "Ja",
      no: "Nee",
      upload: "Laai Op",
      download: "Laai Af",
      replace: "Vervang",
      remove: "Verwyder",
      search: "Soek",
      filter: "Filter",
      all: "Alles",
      none: "Geen",
      optional: "Opsioneel",
      required: "Verpligtend",
      of: "van",
      
      // Toast Messages
      toast: {
        saved: "Gestoor!",
        deleted: "Verwyder!",
        uploaded: "Opgelaai!",
        audioUploaded: "Oudio opgelaai!",
        imageUploaded: "Prent opgelaai!",
        copied: "Gekopieer!",
        copiedToClipboard: "Gekopieer! Plak dit nou in WhatsApp of SMS",
        error: "Fout",
        success: "Sukses!",
        failed: "Misluk",
        tryAgain: "Probeer weer",
        couldNotSave: "Kon nie stoor nie",
        couldNotLoad: "Kon nie laai nie",
        couldNotDelete: "Kon nie verwyder nie",
        couldNotUpload: "Kon nie oplaai nie",
        couldNotGenerate: "Kon nie genereer nie",
        couldNotAnalyze: "Kon nie ontleed nie",
        couldNotSubmit: "Kon nie indien nie",
        couldNotConnect: "Kon nie koppel nie",
        couldNotGetMic: "Kon nie mikrofoon kry nie",
        subscriptionRequired: "Subskripsie vereis",
        accessDenied: "Toegang geweier",
        wellDone: "Goed gedoen!",
        summaryGenerated: "Opsomming gegenereer!",
        allExercisesComplete: "Alle oefeninge voltooi!",
        secondChance: "Tweede kans! Let op: Hierdie poging tel slegs 50%",
        alreadyTwoAttempts: "Jy het reeds twee kanse gehad",
        confirmationEmailSent: "Bevestigings-e-pos gestuur!",
        backupCreated: "Rugsteun geskep!",
        backupRestored: "Rugsteun herstel!",
        audioRestored: "Oudio lêers herstel!",
        registrationSuccess: "Registrasie suksesvol!",
        registrationFailed: "Registrasie het misluk",
        schoolRegistrationReceived: "Skool registrasie ontvang! Ons sal jou kontak.",
        textGenerated: "Teks gegenereer!",
        textSaved: "Teks gestoor!",
        settingsSaved: "Instellings gestoor!",
        instructionsSaved: "Instruksies gestoor!",
        exerciseDeleted: "Oefening verwyder!",
        learnerDeleted: "Leerder verwyder!",
        invitationSent: "Uitnodiging gestuur!",
        passwordChanged: "Wagwoord verander!",
        couldNotPlayWord: "Kon nie woord speel nie",
        couldNotSubmitRequest: "Kon nie aanvraag indien nie",
        selectPreferredDaysTimes: "Kies asseblief voorkeur dae en tye",
        selectPackageFirst: "Kies eers 'n pakket",
        enterReference: "Voer die verwysing in wat jy gebruik het",
        enterAmount: "Voer die bedrag in wat jy betaal het",
        couldNotSubmitPayment: "Kon nie betaling indien nie",
        questionAndAnswerRequired: "Vraag en korrekte antwoord is nodig",
        questionAdded: "Vraag bygevoeg!",
        titleContentRequired: "Titel en inhoud is nodig",
        textUpdated: "Teks opgedateer!",
        couldNotUpdateText: "Kon nie teks opdateer nie",
        recordingUploaded: "Opname opgelaai!",
        couldNotUploadRecording: "Kon nie opname oplaai nie",
        recordingStarted: "Opname begin - praat nou!",
        couldNotGetMicPermission: "Kon nie mikrofoon kry nie - gee asseblief toestemming",
        recordingStopped: "Opname gestop - laai op...",
        couldNotProcessExcel: "Kon nie Excel lêer verwerk nie",
        templateDownloaded: "Template afgelaai!",
        couldNotDownloadTemplate: "Kon nie template aflaai nie",
        couldNotImport: "Kon nie invoer nie",
        couldNotExport: "Kon nie uitvoer nie",
        couldNotLoadLearnerInfo: "Kon nie leerder inligting laai nie",
        tutoringRequestSubmitted: "Tutoring aanvraag ingedien! Ons sal jou kontak.",
        generatingImage: "Genereer prent...",
        imageGenerated: "KI prent gegenereer!",
        couldNotCreate: "Kon nie skep nie",
        textSaved: "Teks geskep!",
        textGenerated: "Teks gegenereer!",
        settingsSaved: "Instellings gestoor!",
        learnerDeleted: "Leerder is uitgevee",
        passwordChanged: "Wagwoord suksesvol verander!"
      },
      
      // Backup & Restore
      backup: {
        title: "Volledige Backup & Herstel",
        subtitle: "Stoor en herstel AL jou data (tekste + oudio lêers)",
        tip: "Maak 'n backup VOOR jy redeploy. Na redeploy, herstel die backup om al jou oudio lêers terug te kry.",
        createBackup: "Maak Backup",
        downloadFull: "Download Volledige Backup",
        downloadFullDesc: "Download 'n ZIP met al jou tekste EN oudio lêers.",
        downloadAudioOnly: "Download Net Oudio (Kleiner)",
        restoreBackup: "Herstel Backup",
        restoreBackupDesc: "Herstel 'n vorige backup (tekste + oudio).",
        restoreFull: "Herstel Volledige Backup (ZIP)",
        restoreAudioOnly: "Herstel Net Oudio Lêers",
        backupNote: "Die backup bevat alle tekste, oudio instruksies, spelling oudio, en ander oudio lêers. Na elke deployment, herstel die backup om al jou data terug te kry.",
        confirmRestore: "Dit sal jou huidige data opdateer met die backup. Gaan voort?",
        creating: "Backup word geskep...",
        restoring: "Backup word herstel...",
        restoringAudio: "Oudio lêers word herstel...",
        restoreComplete: "Herstel voltooi!",
        textsRestored: "Tekste",
        audioRestored: "Oudio",
        logoutReminder: "⚠️ HERINNERING: Jy het oudio opgelaai sedert jou laaste backup.\n\nDit word sterk aanbeveel om 'n backup af te laai voordat jy uitlog, sodat jy nie data verloor na 'n herontplooiing nie.\n\nWil jy steeds uitlog sonder 'n backup?"
      },
      
      // Diagnostic
      diagnostic: {
        title: "Databasis Diagnose",
        subtitle: "Kyk hoeveel tekste per graad gestoor is",
        runDiagnose: "Begin Diagnose",
        fixTexts: "Fix Tekste (Stel Taal)",
        fixTextsDesc: "Stel taal vir tekste wat nie 'n taal het nie"
      },
      
      // Audio
      audio: {
        title: "Oudio Instruksies per Oefening",
        subtitle: "Laai oudio op of neem op vir elke oefening tipe",
        noAudioUploaded: "Geen oudio opgelaai nie",
        noAudioAvailable: "Geen oudio beskikbaar vir hierdie toets nie - vra jou onderwyser om die woorde vir jou te lees",
        uploadAudio: "Laai Oudio Op",
        recordAudio: "Neem Oudio Op",
        playAudio: "Speel Oudio",
        stopAudio: "Stop Oudio",
        recording: "Neem op...",
        playing: "Speel...",
        howItWorks: "Wanneer 'n leerder op 'n oefening klik, sal hierdie oudio outomaties speel om hulle te vertel wat om te doen."
      },
      
      // Exercises
      exercises: {
        loadingExercises: "Laai oefeninge...",
        noExercisesYet: "Nog geen oefeninge voltooi nie",
        allComplete: "Alle oefeninge voltooi!",
        seeOptions: "Sien opsies",
        attempt: "Poging",
        score: "Telling",
        secondAttempt: "Tweede poging"
      },
      
      // Form Labels
      form: {
        enterName: "Voer die leerder se naam en van in",
        selectGrade: "Kies Graad",
        selectLanguage: "Kies Taal",
        addParentDetails: "Voeg jou ouer se besonderhede by sodat hulle toegang kry tot die ouerportaal."
      },
      
      // Landing Page
      landing: {
        title: "Lees is Duidelik",
        subtitle: "Waar lees pret word!",
        tagline: "Interaktiewe leesplatform vir Suid-Afrikaanse kinders",
        getStarted: "Begin Nou",
        login: "Meld Aan",
        features: {
          title: "Waarom Lees is Duidelik?",
          reading: "Leesvaardighede",
          readingDesc: "Verbeter lees met interaktiewe oefeninge",
          comprehension: "Begrip",
          comprehensionDesc: "Verstaan wat jy lees met doelgerigte vrae",
          spelling: "Spelling",
          spellingDesc: "Oefen spelling met pret aktiwiteite",
          progress: "Vordering",
          progressDesc: "Volg jou groei met gedetailleerde verslae"
        },
        pricing: {
          title: "Pryse",
          trial: "7 dae gratis proeftydperk",
          monthly: "maand",
          week: "week",
          perLearner: "per leerder"
        },
        tutoring: {
          title: "Online Tutoring",
          desc: "Persoonlike een-op-een sessies met 'n gekwalifiseerde onderwyser",
          personalAttention: "Persoonlike aandag vir jou kind",
          flexibleTimes: "Buigsame tye wat by jou pas",
          focusReading: "Fokus op lees & begrip",
          enquire: "Vra Aan / Kontak Ons"
        }
      },
      
      // Authentication
      auth: {
        login: "Meld Aan",
        register: "Registreer",
        logout: "Teken Uit",
        learner: "Leerder",
        school: "Skool",
        admin: "Admin",
        parent: "Ouer",
        email: "E-pos",
        password: "Wagwoord",
        confirmPassword: "Bevestig Wagwoord",
        username: "Gebruikersnaam",
        invitationCode: "Uitnodigingskode",
        name: "Naam",
        surname: "Van",
        grade: "Graad",
        whatsapp: "WhatsApp / Sel Nommer",
        parentDetails: "Ouer/Voog Besonderhede",
        parentEmail: "Ouer E-pos",
        parentWhatsapp: "Ouer WhatsApp / Sel Nommer",
        parentPermission: "Ek bevestig dat my ouer/voog toestemming gegee het",
        forgotPassword: "Wagwoord vergeet?",
        noAccount: "Nog nie geregistreer nie?",
        hasAccount: "Reeds geregistreer?",
        trialInfo: "Met uitnodigingskode: 7 dae gratis proeftydperk!",
        parentRequired: "Ouer WhatsApp / Sel nommer is verpligtend",
        invalidCredentials: "Ongeldige aanmeldbesonderhede",
        registrationSuccess: "Registrasie suksesvol!"
      },
      
      // Dashboard
      dashboard: {
        hello: "Hallo",
        yourProgress: "Jou Vordering",
        exercises: "Oefeninge",
        average: "Gemiddeld",
        wpm: "WPM",
        levelProgress: "Vlak Vordering",
        currentLevel: "Huidige Leesvlak",
        retakeTest: "Herdoen Toets",
        tooHighOrLow: "Te hoog of te laag? Herdoen die toets.",
        practiceLevel: "Op watter vlak wil jy oefen?",
        readingLevel: "Leesvlak",
        schoolGrade: "Skool",
        allCompleted: "Alle oefeninge voltooi!",
        seeOptions: "Sien opsies"
      },
      
      // Exercise Types
      exerciseTypes: {
        comprehension: "Begrip",
        comprehensionDesc: "Lees en beantwoord vrae",
        reading: "Hardoplees",
        readingDesc: "Neem jouself op",
        listening: "Luister",
        listeningDesc: "Luister en leer",
        spelling: "Spelling",
        spellingDesc: "Oefen jou spelling",
        woordbou: "Woordbou",
        woordbouDesc: "Bou woorde met letters",
        klanktoets: "Klanktoets",
        klanktoetsDesc: "Luister en skryf klanke",
        alfabet: "Alfabet",
        alfabetDesc: "Leer die alfabet"
      },
      
      // Reading Test
      readingTest: {
        title: "Leesvlaktoets",
        instructions: "Lees die volgende teks so vinnig en akkuraat as moontlik.",
        startReading: "Begin Lees",
        finishReading: "Klaar Gelees",
        howManyWords: "Hoeveel woorde het jy gelees?",
        howManyErrors: "Hoeveel foute het jy gemaak?",
        excellent: "Uitstekend!",
        wordsPerMinute: "woorde per minuut",
        chooseLevel: "Op watter vlak wil jy oefen?",
        levelLower: "Jou leesvlak is Graad {{level}}, maar jy is in Graad {{grade}} op skool.",
        myReadingLevel: "My leesvlak",
        mySchoolGrade: "My skoolgraad",
        goToDashboard: "Gaan na Dashboard"
      },
      
      // Subscription
      subscription: {
        title: "Subskripsie",
        trial: "Proeftydperk",
        trialExpired: "Jou proeftydperk het verval",
        daysLeft: "dae oor",
        subscribe: "Teken In",
        active: "Aktief",
        expired: "Verval"
      },
      
      // Admin
      admin: {
        dashboard: "Admin Dashboard",
        overview: "Oorsig",
        learners: "Leerders",
        schools: "Skole",
        texts: "Tekste",
        woordbou: "Woordbou",
        klanktoets: "Klanktoets",
        alfabet: "Alfabet",
        generate: "Genereer",
        settings: "Instellings",
        tutoring: "Tutoring",
        totalLearners: "Totale Leerders",
        activeToday: "Aktief Vandag",
        totalTexts: "Totale Tekste",
        createNew: "Skep Nuwe",
        bulkImport: "Bulk Invoer",
        downloadTemplate: "Laai Template Af",
        import: "Invoer",
        exerciseInstructions: "Oefening Instruksies",
        encouragementMessage: "Bemoedigende Boodskap",
        saveInstructions: "Stoor Instruksies",
        // New keys for i18n sweep
        saveText: "Stoor Teks",
        editText: "Wysig Teks",
        addQuestion: "Voeg By",
        uploadAudio: "Laai Oudio Op",
        uploadImage: "Laai Prent Op",
        replaceImage: "Vervang Prent",
        uploadFile: "Laai Lêer Op",
        uploading: "Laai op...",
        replace: "Vervang",
        saveChanges: "Stoor Wysigings",
        editContact: "Wysig",
        cancelEdit: "Kanselleer",
        saveContact: "Stoor",
        loadingText: "Laai...",
        refreshData: "Verfris Data",
        loadAnalytics: "Laai Analytics",
        paymentDate: "Datum van Betaling",
        submitPayment: "Dien Betaling In",
        submitting: "Besig...",
        confirmed: "Bevestig",
        confirm: "Bevestig",
        pendingPayments: "Waggende Betalings",
        saveBankDetails: "Stoor Bankbesonderhede",
        editSchool: "Wysig Skool",
        confirmPayment: "Bevestig Betaling",
        paidConfirmed: "Betaal ✓",
        paymentConfirmed: "Betaling bevestig! Leerders kan nou aanhou.",
        paymentSuccess: "Betaling suksesvol! Dankie!",
        createParentLink: "Skep Ouer Portaal Skakel",
        downloadReport: "Laai Leesvorderingverslag Af (PDF)",
        downloadReportDesc: "Laai 'n PDF verslag af met die leerder se WPM groei en toetsgeskiedenis.",
        resettingPassword: "Besig...",
        activate: "Aktiveer",
        suspend: "Suspend",
        learnerActivated: "Leerder geaktiveer",
        learnerSuspended: "Leerder gesuspendeer",
        waitingPayment: "Wag vir Betaling Bevestiging",
        monthlyExpiredMsg: "Hierdie leerder se 30-dae subskripsie het verval. Aktiveer weer na betalingsbevestiging.",
        activateMonthly: "Aktiveer Maandelikse Subskripsie (30 dae)",
        activateLifetime: "Aktiveer Rekening (Lewenslank)",
        renewMonthly: "Hernu Maandelikse Subskripsie (30 dae)",
        // Bulk Import
        bulkImportDesc: "Laai verskeie tekste op een slag op vanaf 'n Excel lêer. Laai eers die template af om die korrekte formaat te sien.",
        uploadExcel: "Laai Excel Op",
        // Alphabet
        alphabetInstructions: "Laai 'n prent en klank op vir elke letter (bv. \"A is vir Appel\").",
        alphabetTip: "Laai jou eie oudio op, of klik \"Genereer KI Prente\" om outomaties prente te skep vir elke letter.",
        uploadOwnImage: "Laai eie prent op",
        // Spelling Audio
        spellingAudioTitle: "Speltoets Woord Oudio",
        spellingAudioDesc: "Laai jou eie oudio op vir speltoetse. Leerders sal jou stem hoor in plaas van KI.",
        uploadAllSpellingZip: "Laai ALLE Spelling Oudio Op (ZIP)",
        uploadZip: "Laai ZIP Op",
        // Text audio
        uploadAudioForWords: "Laai jou eie oudio op vir elke woord (MP3, WAV, M4A)",
        // Export/Import
        exportImportTip: "Laai af of voer tekste in om data te behou",
        // Diagnostics
        noLanguageWarning: "* \"Geen Taal\" tekste sal nie laai vir leerders nie. Klik \"Fix Tekste\" om dit reg te maak.",
        // Logo
        uploadLogo: "Laai Logo Op",
        replaceLogo: "Vervang Logo",
        savingSettings: "Stoor...",
        saveSettings: "Stoor Instellings",
        // Link learner
        linkingLearner: "Koppel...",
        linkLearner: "Koppel Leerder"
      },
      
      // Progress Modal
      progressModal: {
        congratulations: "Baie Geluk!",
        allCompleted: "Jy het al die oefeninge vir Graad {{level}} voltooi!",
        whatNext: "Wat wil jy nou doen?",
        goToNextLevel: "Gaan na Graad {{level}}",
        retakeTest: "Doen Leesvlaktoets Weer",
        stayOnLevel: "Sluit (bly op Graad {{level}})"
      },
      
      // Woordbou
      woordbou: {
        title: "Woordbou",
        buildWord: "Bou die woord",
        dragLetters: "Sleep die letters om die woord te bou",
        checkAnswer: "Kyk Antwoord",
        correct: "Korrek!",
        tryAgain: "Probeer weer",
        challenge: "Woordbou Uitdaging",
        leaderboard: "Ranglys",
        yourStats: "Jou Statistieke",
        streak: "Reeks",
        accuracy: "Akkuraatheid",
        noExercises: "Geen Woordbou Oefeninge",
        noExercisesDesc: "Daar is tans geen oefeninge vir jou graad nie."
      },
      
      // Klanktoets
      klanktoets: {
        title: "Klanktoets",
        listenAndWrite: "Luister en skryf",
        playSound: "Speel Klank",
        typeWord: "Tik die woord",
        noExercises: "Geen Klanktoetse",
        noExercisesDesc: "Daar is tans geen toetse vir jou graad nie.",
        testProgress: "Toets",
        existingTests: "Bestaande Klanktoetse",
        noTestsCreated: "Geen klanktoetse geskep nie",
        editItems: "Wysig Woorde",
        addNewWord: "Voeg nuwe woord by (bv. boom)",
        addWord: "Voeg By",
        words: "woorde",
        confirmDelete: "Is jy seker jy wil hierdie toets verwyder?",
        addTitleAndItem: "Voeg titel en ten minste een item by",
        created: "Klanktoets geskep! Laai nou oudio/prente op vir elke item.",
        create: "Skep Klanktoets"
      },
      
      // Alfabet
      alfabet: {
        title: "Alfabet",
        clickToLearn: "Klik op 'n letter om te leer",
        isFor: "is vir",
        listenAgain: "Luister weer",
        tip: "Wenk: Klik op elke letter om die woord en prentjie te sien."
      },
      
      // Common
      common: {
        back: "Terug",
        backToDashboard: "Terug na Dashboard"
      },
      
      // Profile
      profile: {
        currentReadingLevel: "Huidige Leesvlak",
        tooHighOrLow: "Te hoog of te laag? Herdoen die toets.",
        retakeTest: "Herdoen Toets",
        practiceLevel: "Op watter vlak wil jy oefen?",
        readingLevelLabel: "Leesvlak",
        schoolGradeLabel: "Skool",
        timeForRetest: "Dit is tyd vir jou 3-maandelikse leesvlaktoets!",
        takeTestNow: "Doen Toets Nou",
        allExercisesComplete: "Alle oefeninge voltooi!",
        seeOptions: "Sien opsies"
      },
      
      // Reading Test Extended
      readingTestExt: {
        title: "Leesvlaktoets",
        wordsText: "woorde",
        readText: "Lees die volgende teks so vinnig en akkuraat as moontlik.",
        determineLevel: "Ons sal jou leesvlak bepaal op grond van jou spoed.",
        startTest: "Begin Toets",
        readAloud: "Lees Hardop",
        timing: "Tydsberekening...",
        howManyWords: "Hoeveel woorde het jy gelees? (opsioneel)",
        howManyErrors: "Hoeveel foute het jy gemaak?",
        doneReading: "Klaar Gelees",
        excellent: "Uitstekend!",
        wordsPerMinute: "woorde per minuut",
        chooseLevel: "Op watter vlak wil jy oefen?",
        yourLevelIs: "Jou leesvlak is Graad {{level}}, maar jy is in Graad {{grade}} op skool.",
        practiceAt: "Jy sal op Graad {{grade}} oefen",
        couldNotSave: "Kon nie stoor nie",
        couldNotSaveResult: "Kon nie resultaat stoor nie",
        myReadingLevel: "My leesvlak",
        mySchoolGrade: "My skoolgraad",
        goToDashboard: "Gaan na Dashboard"
      },

      // Progress
      progress: {
        congratulations: "Baie Geluk!",
        completedAll: "Jy het al die oefeninge vir Graad {{level}} voltooi!",
        whatNext: "Wat wil jy nou doen?",
        goToGrade: "Gaan na Graad {{level}}",
        couldNotProgress: "Kon nie opskuif nie",
        couldNotChange: "Kon nie verander nie",
        levelChanged: "Oefenvlak verander na Graad {{level}}"
      },
      
      // Messages
      messages: {
        saved: "Gestoor!",
        deleted: "Verwyder!",
        error: "Fout",
        success: "Sukses",
        tryAgain: "Probeer weer",
        noData: "Geen data beskikbaar nie",
        loading: "Laai...",
        optional: "Opsioneel"
      },
      
      // Language
      language: {
        select: "Kies Taal",
        afrikaans: "Afrikaans",
        english: "English"
      }
    }
  },
  
  en: {
    translation: {
      // Common
      loading: "Loading...",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      edit: "Edit",
      back: "Back",
      next: "Next",
      submit: "Submit",
      close: "Close",
      yes: "Yes",
      no: "No",
      upload: "Upload",
      download: "Download",
      replace: "Replace",
      remove: "Remove",
      search: "Search",
      filter: "Filter",
      all: "All",
      none: "None",
      optional: "Optional",
      required: "Required",
      of: "of",
      
      // Toast Messages
      toast: {
        saved: "Saved!",
        deleted: "Deleted!",
        uploaded: "Uploaded!",
        audioUploaded: "Audio uploaded!",
        imageUploaded: "Image uploaded!",
        copied: "Copied!",
        copiedToClipboard: "Copied! Paste it now in WhatsApp or SMS",
        error: "Error",
        success: "Success!",
        failed: "Failed",
        tryAgain: "Try again",
        couldNotSave: "Could not save",
        couldNotLoad: "Could not load",
        couldNotDelete: "Could not delete",
        couldNotUpload: "Could not upload",
        couldNotGenerate: "Could not generate",
        couldNotAnalyze: "Could not analyze",
        couldNotSubmit: "Could not submit",
        couldNotConnect: "Could not connect",
        couldNotGetMic: "Could not access microphone",
        subscriptionRequired: "Subscription required",
        accessDenied: "Access denied",
        wellDone: "Well done!",
        summaryGenerated: "Summary generated!",
        allExercisesComplete: "All exercises complete!",
        secondChance: "Second chance! Note: This attempt counts only 50%",
        alreadyTwoAttempts: "You've already had two attempts",
        confirmationEmailSent: "Confirmation email sent!",
        backupCreated: "Backup created!",
        backupRestored: "Backup restored!",
        audioRestored: "Audio files restored!",
        registrationSuccess: "Registration successful!",
        registrationFailed: "Registration failed",
        schoolRegistrationReceived: "School registration received! We will contact you.",
        textGenerated: "Text generated!",
        textSaved: "Text saved!",
        settingsSaved: "Settings saved!",
        instructionsSaved: "Instructions saved!",
        exerciseDeleted: "Exercise deleted!",
        learnerDeleted: "Learner deleted!",
        invitationSent: "Invitation sent!",
        passwordChanged: "Password changed!",
        couldNotPlayWord: "Could not play word",
        couldNotSubmitRequest: "Could not submit request",
        selectPreferredDaysTimes: "Please select preferred days and times",
        selectPackageFirst: "Please select a package first",
        enterReference: "Enter the reference you used",
        enterAmount: "Enter the amount you paid",
        couldNotSubmitPayment: "Could not submit payment",
        questionAndAnswerRequired: "Question and correct answer required",
        questionAdded: "Question added!",
        titleContentRequired: "Title and content required",
        textUpdated: "Text updated!",
        couldNotUpdateText: "Could not update text",
        recordingUploaded: "Recording uploaded!",
        couldNotUploadRecording: "Could not upload recording",
        recordingStarted: "Recording started - speak now!",
        couldNotGetMicPermission: "Could not access microphone - please grant permission",
        recordingStopped: "Recording stopped - uploading...",
        couldNotProcessExcel: "Could not process Excel file",
        templateDownloaded: "Template downloaded!",
        couldNotDownloadTemplate: "Could not download template",
        couldNotImport: "Could not import",
        couldNotExport: "Could not export",
        couldNotLoadLearnerInfo: "Could not load learner info",
        tutoringRequestSubmitted: "Tutoring request submitted! We will contact you.",
        generatingImage: "Generating image...",
        imageGenerated: "AI image generated!",
        couldNotCreate: "Could not create",
        textSaved: "Text created!",
        textGenerated: "Text generated!",
        settingsSaved: "Settings saved!",
        learnerDeleted: "Learner deleted",
        passwordChanged: "Password changed successfully!"
      },
      
      // Backup & Restore
      backup: {
        title: "Full Backup & Restore",
        subtitle: "Store and restore ALL your data (texts + audio files)",
        tip: "Create a backup BEFORE you redeploy. After redeploy, restore the backup to get all your audio files back.",
        createBackup: "Create Backup",
        downloadFull: "Download Full Backup",
        downloadFullDesc: "Download a ZIP with all your texts AND audio files.",
        downloadAudioOnly: "Download Audio Only (Smaller)",
        restoreBackup: "Restore Backup",
        restoreBackupDesc: "Restore a previous backup (texts + audio).",
        restoreFull: "Restore Full Backup (ZIP)",
        restoreAudioOnly: "Restore Audio Files Only",
        backupNote: "The backup contains all texts, audio instructions, spelling audio, and other audio files. After each deployment, restore the backup to get all your data back.",
        confirmRestore: "This will update your current data with the backup. Continue?",
        creating: "Creating backup...",
        restoring: "Restoring backup...",
        restoringAudio: "Restoring audio files...",
        restoreComplete: "Restore complete!",
        textsRestored: "Texts",
        audioRestored: "Audio",
        logoutReminder: "⚠️ REMINDER: You have uploaded audio since your last backup.\n\nIt is strongly recommended to download a backup before logging out, so you don't lose data after a redeployment.\n\nDo you still want to log out without a backup?"
      },
      
      // Diagnostic
      diagnostic: {
        title: "Database Diagnostic",
        subtitle: "See how many texts are stored per grade",
        runDiagnose: "Run Diagnostic",
        fixTexts: "Fix Texts (Set Language)",
        fixTextsDesc: "Set language for texts that don't have one"
      },
      
      // Audio
      audio: {
        title: "Audio Instructions per Exercise",
        subtitle: "Upload or record audio for each exercise type",
        noAudioUploaded: "No audio uploaded",
        noAudioAvailable: "No audio available for this test - ask your teacher to read the words to you",
        uploadAudio: "Upload Audio",
        recordAudio: "Record Audio",
        playAudio: "Play Audio",
        stopAudio: "Stop Audio",
        recording: "Recording...",
        playing: "Playing...",
        howItWorks: "When a learner clicks on an exercise, this audio will automatically play to tell them what to do."
      },
      
      // Exercises
      exercises: {
        loadingExercises: "Loading exercises...",
        noExercisesYet: "No exercises completed yet",
        allComplete: "All exercises complete!",
        seeOptions: "See options",
        attempt: "Attempt",
        score: "Score",
        secondAttempt: "Second attempt"
      },
      
      // Form Labels
      form: {
        enterName: "Enter the learner's name and surname",
        selectGrade: "Select Grade",
        selectLanguage: "Select Language",
        addParentDetails: "Add your parent's details so they can access the parent portal."
      },
      
      // Landing Page
      landing: {
        title: "Lees is Duidelik",
        subtitle: "Where reading becomes fun!",
        tagline: "Interactive reading platform for South African children",
        getStarted: "Get Started",
        login: "Login",
        features: {
          title: "Why Lees is Duidelik?",
          reading: "Reading Skills",
          readingDesc: "Improve reading with interactive exercises",
          comprehension: "Comprehension",
          comprehensionDesc: "Understand what you read with targeted questions",
          spelling: "Spelling",
          spellingDesc: "Practice spelling with fun activities",
          progress: "Progress",
          progressDesc: "Track your growth with detailed reports"
        },
        pricing: {
          title: "Pricing",
          trial: "7 days free trial",
          monthly: "month",
          week: "week",
          perLearner: "per learner"
        },
        tutoring: {
          title: "Online Tutoring",
          desc: "Personal one-on-one sessions with a qualified teacher",
          personalAttention: "Personal attention for your child",
          flexibleTimes: "Flexible times that suit you",
          focusReading: "Focus on reading & comprehension",
          enquire: "Enquire / Contact Us"
        }
      },
      
      // Authentication
      auth: {
        login: "Login",
        register: "Register",
        logout: "Logout",
        learner: "Learner",
        school: "School",
        admin: "Admin",
        parent: "Parent",
        email: "Email",
        password: "Password",
        confirmPassword: "Confirm Password",
        username: "Username",
        invitationCode: "Invitation Code",
        name: "Name",
        surname: "Surname",
        grade: "Grade",
        whatsapp: "WhatsApp / Cell Number",
        parentDetails: "Parent/Guardian Details",
        parentEmail: "Parent Email",
        parentWhatsapp: "Parent WhatsApp / Cell Number",
        parentPermission: "I confirm that my parent/guardian has given permission",
        forgotPassword: "Forgot password?",
        noAccount: "Not registered yet?",
        hasAccount: "Already registered?",
        trialInfo: "With invitation code: 7 days free trial!",
        parentRequired: "Parent WhatsApp / Cell number is required",
        invalidCredentials: "Invalid login details",
        registrationSuccess: "Registration successful!"
      },
      
      // Dashboard
      dashboard: {
        hello: "Hello",
        yourProgress: "Your Progress",
        exercises: "Exercises",
        average: "Average",
        wpm: "WPM",
        levelProgress: "Level Progress",
        currentLevel: "Current Reading Level",
        retakeTest: "Retake Test",
        tooHighOrLow: "Too high or too low? Retake the test.",
        practiceLevel: "Which level do you want to practice?",
        readingLevel: "Reading Level",
        schoolGrade: "School",
        allCompleted: "All exercises completed!",
        seeOptions: "See options"
      },
      
      // Exercise Types
      exerciseTypes: {
        comprehension: "Comprehension",
        comprehensionDesc: "Read and answer questions",
        reading: "Read Aloud",
        readingDesc: "Record yourself",
        listening: "Listening",
        listeningDesc: "Listen and learn",
        spelling: "Spelling",
        spellingDesc: "Practice your spelling",
        woordbou: "Word Building",
        woordbouDesc: "Build words with letters",
        klanktoets: "Sound Test",
        klanktoetsDesc: "Listen and write sounds",
        alfabet: "Alphabet",
        alfabetDesc: "Learn the alphabet"
      },
      
      // Reading Test
      readingTest: {
        title: "Reading Level Test",
        instructions: "Read the following text as quickly and accurately as possible.",
        startReading: "Start Reading",
        finishReading: "Finish Reading",
        howManyWords: "How many words did you read?",
        howManyErrors: "How many errors did you make?",
        excellent: "Excellent!",
        wordsPerMinute: "words per minute",
        chooseLevel: "Which level do you want to practice?",
        levelLower: "Your reading level is Grade {{level}}, but you are in Grade {{grade}} at school.",
        myReadingLevel: "My reading level",
        mySchoolGrade: "My school grade",
        goToDashboard: "Go to Dashboard"
      },
      
      // Subscription
      subscription: {
        title: "Subscription",
        trial: "Trial Period",
        trialExpired: "Your trial period has expired",
        daysLeft: "days left",
        subscribe: "Subscribe",
        active: "Active",
        expired: "Expired"
      },
      
      // Admin
      admin: {
        dashboard: "Admin Dashboard",
        overview: "Overview",
        learners: "Learners",
        schools: "Schools",
        texts: "Texts",
        woordbou: "Word Building",
        klanktoets: "Sound Test",
        alfabet: "Alphabet",
        generate: "Generate",
        settings: "Settings",
        tutoring: "Tutoring",
        totalLearners: "Total Learners",
        activeToday: "Active Today",
        totalTexts: "Total Texts",
        createNew: "Create New",
        bulkImport: "Bulk Import",
        downloadTemplate: "Download Template",
        import: "Import",
        exerciseInstructions: "Exercise Instructions",
        encouragementMessage: "Encouragement Message",
        saveInstructions: "Save Instructions",
        // New keys for i18n sweep
        saveText: "Save Text",
        editText: "Edit Text",
        addQuestion: "Add",
        uploadAudio: "Upload Audio",
        uploadImage: "Upload Image",
        replaceImage: "Replace Image",
        uploadFile: "Upload File",
        uploading: "Uploading...",
        replace: "Replace",
        saveChanges: "Save Changes",
        editContact: "Edit",
        cancelEdit: "Cancel",
        saveContact: "Save",
        loadingText: "Loading...",
        refreshData: "Refresh Data",
        loadAnalytics: "Load Analytics",
        paymentDate: "Payment Date",
        submitPayment: "Submit Payment",
        submitting: "Submitting...",
        confirmed: "Confirmed",
        confirm: "Confirm",
        pendingPayments: "Pending Payments",
        saveBankDetails: "Save Bank Details",
        editSchool: "Edit School",
        confirmPayment: "Confirm Payment",
        paidConfirmed: "Paid ✓",
        paymentConfirmed: "Payment confirmed! Learners can now continue.",
        paymentSuccess: "Payment successful! Thank you!",
        createParentLink: "Create Parent Portal Link",
        downloadReport: "Download Reading Progress Report (PDF)",
        downloadReportDesc: "Download a PDF report with the learner's WPM growth and test history.",
        resettingPassword: "Processing...",
        activate: "Activate",
        suspend: "Suspend",
        learnerActivated: "Learner activated",
        learnerSuspended: "Learner suspended",
        waitingPayment: "Waiting for Payment Confirmation",
        monthlyExpiredMsg: "This learner's 30-day subscription has expired. Activate again after payment confirmation.",
        activateMonthly: "Activate Monthly Subscription (30 days)",
        activateLifetime: "Activate Account (Lifetime)",
        renewMonthly: "Renew Monthly Subscription (30 days)",
        // Bulk Import
        bulkImportDesc: "Upload multiple texts at once from an Excel file. Download the template first to see the correct format.",
        uploadExcel: "Upload Excel",
        // Alphabet
        alphabetInstructions: "Upload an image and sound for each letter (e.g. \"A is for Apple\").",
        alphabetTip: "Upload your own audio, or click \"Generate AI Images\" to automatically create images for each letter.",
        uploadOwnImage: "Upload own image",
        // Spelling Audio
        spellingAudioTitle: "Spelling Word Audio",
        spellingAudioDesc: "Upload your own audio for spelling tests. Learners will hear your voice instead of AI.",
        uploadAllSpellingZip: "Upload ALL Spelling Audio (ZIP)",
        uploadZip: "Upload ZIP",
        // Text audio
        uploadAudioForWords: "Upload your own audio for each word (MP3, WAV, M4A)",
        // Export/Import
        exportImportTip: "Download or import texts to preserve data",
        // Diagnostics
        noLanguageWarning: "* \"No Language\" texts will not load for learners. Click \"Fix Texts\" to fix this.",
        // Logo
        uploadLogo: "Upload Logo",
        replaceLogo: "Replace Logo",
        savingSettings: "Saving...",
        saveSettings: "Save Settings",
        // Link learner
        linkingLearner: "Linking...",
        linkLearner: "Link Learner"
      },
      
      // Progress Modal
      progressModal: {
        congratulations: "Congratulations!",
        allCompleted: "You have completed all exercises for Grade {{level}}!",
        whatNext: "What do you want to do now?",
        goToNextLevel: "Go to Grade {{level}}",
        retakeTest: "Retake Reading Level Test",
        stayOnLevel: "Close (stay on Grade {{level}})"
      },
      
      // Woordbou
      woordbou: {
        title: "Word Building",
        buildWord: "Build the word",
        dragLetters: "Drag the letters to build the word",
        checkAnswer: "Check Answer",
        correct: "Correct!",
        tryAgain: "Try again",
        challenge: "Word Building Challenge",
        leaderboard: "Leaderboard",
        yourStats: "Your Statistics",
        streak: "Streak",
        accuracy: "Accuracy",
        noExercises: "No Word Building Exercises",
        noExercisesDesc: "There are currently no exercises for your grade."
      },
      
      // Klanktoets
      klanktoets: {
        title: "Sound Test",
        listenAndWrite: "Listen and write",
        playSound: "Play Sound",
        typeWord: "Type the word",
        noExercises: "No Sound Tests",
        noExercisesDesc: "There are currently no tests for your grade.",
        testProgress: "Test",
        existingTests: "Existing Sound Tests",
        noTestsCreated: "No sound tests created yet",
        editItems: "Edit Words",
        addNewWord: "Add new word (e.g. tree)",
        addWord: "Add",
        words: "words",
        confirmDelete: "Are you sure you want to delete this test?",
        addTitleAndItem: "Add a title and at least one item",
        created: "Sound test created! Now upload audio/images for each item.",
        create: "Create Sound Test"
      },
      
      // Alfabet
      alfabet: {
        title: "Alphabet",
        clickToLearn: "Click on a letter to learn",
        isFor: "is for",
        listenAgain: "Listen again",
        tip: "Tip: Click on each letter to see the word and picture."
      },
      
      // Common
      common: {
        back: "Back",
        backToDashboard: "Back to Dashboard"
      },
      
      // Profile
      profile: {
        currentReadingLevel: "Current Reading Level",
        tooHighOrLow: "Too high or too low? Retake the test.",
        retakeTest: "Retake Test",
        practiceLevel: "Which level do you want to practice?",
        readingLevelLabel: "Reading Level",
        schoolGradeLabel: "School",
        timeForRetest: "It's time for your 3-monthly reading level test!",
        takeTestNow: "Take Test Now",
        allExercisesComplete: "All exercises completed!",
        seeOptions: "See options"
      },
      
      // Reading Test Extended
      readingTestExt: {
        title: "Reading Level Test",
        wordsText: "words",
        readText: "Read the following text as quickly and accurately as possible.",
        determineLevel: "We will determine your reading level based on your speed.",
        startTest: "Start Test",
        readAloud: "Read Aloud",
        timing: "Timing...",
        howManyWords: "How many words did you read? (optional)",
        howManyErrors: "How many errors did you make?",
        doneReading: "Done Reading",
        excellent: "Excellent!",
        wordsPerMinute: "words per minute",
        chooseLevel: "Which level do you want to practice?",
        yourLevelIs: "Your reading level is Grade {{level}}, but you are in Grade {{grade}} at school.",
        practiceAt: "You will practice at Grade {{grade}}",
        couldNotSave: "Could not save",
        couldNotSaveResult: "Could not save result",
        myReadingLevel: "My reading level",
        mySchoolGrade: "My school grade",
        goToDashboard: "Go to Dashboard"
      },

      // Progress
      progress: {
        congratulations: "Congratulations!",
        completedAll: "You have completed all exercises for Grade {{level}}!",
        whatNext: "What do you want to do now?",
        goToGrade: "Go to Grade {{level}}",
        couldNotProgress: "Could not progress",
        couldNotChange: "Could not change",
        levelChanged: "Practice level changed to Grade {{level}}"
      },
      
      // Messages
      messages: {
        saved: "Saved!",
        deleted: "Deleted!",
        error: "Error",
        success: "Success",
        tryAgain: "Try again",
        noData: "No data available",
        loading: "Loading...",
        optional: "Optional"
      },
      
      // Language
      language: {
        select: "Select Language",
        afrikaans: "Afrikaans",
        english: "English"
      }
    }
  }
};

export default translations;
